import type { FieldComponents } from '@/shared/components/form-fields/types';
import { createFormHook } from '@tanstack/react-form';
import { fieldContext, formContext } from './form-context.hook';
import { ProposalFormFields } from './form-fields';

/**
 * Field components tipados para Proposals
 * Use este tipo ao tipar manualmente o field no children
 *
 * @example
 * ```tsx
 * <form.AppField
 *   name="email"
 *   children={(field: ProposalFieldComponents) => (
 *     <field.TextField label="Email" />
 *   )}
 * />
 * ```
 */
export type ProposalFieldComponents = FieldComponents;

const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField: ProposalFormFields.TextField,
    NumberField: ProposalFormFields.NumberField,
    DateField: ProposalFormFields.DateField,
    CheckboxField: ProposalFormFields.CheckboxField,
    SelectField: ProposalFormFields.SelectField,
    RadioButtonGroup: ProposalFormFields.RadioButtonGroup,
    CalendarField: ProposalFormFields.CalendarField,
  },
  formComponents: {},
});

export { useAppForm as useProposalForm, withForm };
